import './LogbookModal.css';

import B2BPopUpForm from '../../b2b-common/B2BPopUpForm';
import ShowHideSection from '../../b2b-common/ShowHideSection';
import GenericTabs from '../../b2b-common/GenericTabs';
import FolderNavigator from '../components/FolderNavigator';
import ConfirmationDialog from '../../b2b-common/ConfirmationDialog';
import Banner from '../../b2b-common/Banner';
import { AutoStories } from '@mui/icons-material';

const LogbookModal = ({
    currentOpen,
    currentLogbook,
    currentFolder,
    newLogbookConfirmationRequest,
    setNewLogbookConfirmationRequest,
    logbookDeleteConfirmationRequest,
    setLogbookDeleteConfirmationRequest,
    handleCreateNewLogbook,
    handleUpdatedLogbook,
    handleFolderChange,
    handleDeleteLogbook,
    handleClose,

    showHeader,
    setShowHeader,
    tabsConfig,
    t,
    headerTitle,
    headerMessage,
}) => {
    
    return (
        <div onClick={(event) => event.stopPropagation()}>
            <B2BPopUpForm
                icon={<AutoStories />}
                open={currentLogbook && currentOpen}
                title={t('Logbook')}
                onClose={handleClose}
                maxWidth='lg'
                className={'b2b-logbook-modal'}
            >
                <ShowHideSection open={showHeader} setOpen={setShowHeader}
                    header={
                        <Banner sectionTittle={headerTitle} message={headerMessage} headingLevel='h4' underline={false} />
                    }
                    className={'b2b-logbook-modal-head'}
                >
                    <GenericTabs tabsConfig={tabsConfig} className={'b2b-logbook-sections'} />
                </ShowHideSection>
                <div className="b2b-logbook-content">
                    <FolderNavigator logbook={currentLogbook}
                        folder={currentFolder}
                        onUpdatedLogbook={handleUpdatedLogbook}
                        onFolderChange={handleFolderChange}
                        onDeleteLogbook={() => setLogbookDeleteConfirmationRequest(true)}
                    />
                </div>
            </B2BPopUpForm >
            <ConfirmationDialog
                title={t('New logbook')}
                mainText={t('If you confirm a new logbook will be created.')}
                open={newLogbookConfirmationRequest}
                onClose={() => setNewLogbookConfirmationRequest(false)}
                onConfirm={handleCreateNewLogbook}
            />
            <ConfirmationDialog
                title={t('Delete logbook')}
                mainText={t('Are you sure you want to delete this logbook?')}
                open={logbookDeleteConfirmationRequest}
                onClose={() => setLogbookDeleteConfirmationRequest(false)}
                onConfirm={handleDeleteLogbook}
            />
        </div>
    );
};

export default LogbookModal;